<template>
  <div class="icon">
    <div class="sidebar">
      <Avatar 
        size="large"
        :name="user.name"
        :image="user.avatar"
      />
    </div>
    <div class="main">
      <div class="row">
        <label>Name</label>
        <span>{{user.name}} <VerifiedIcon v-if="user.sponsor" /></span>
        <span v-if="user.title" class="title">{{user.title}}</span>
      </div>
      
      <div v-if="user.email && visualSettings.userCardMetaEmail" class="row">
        <label>Email Address</label>
        <span>{{user.email}}</span>
      </div>

      <div v-if="user.phone" class="row">
        <label>Phone Number</label>
        <span>{{user.phone}}</span>
      </div>

      <div v-if="user.facebookUrl" class="row">
        <label>Facebook</label>
        <span><a :href="`https://www.facebook.com/${user.facebookUrl}`" target="_blank">@{{user.facebookUrl}}</a></span>
      </div>

      <div v-if="user.bio" class="row">
        <label>Bio</label>
        <span>{{user.bio}}</span>
      </div>

      <hr v-if="showDirectMessageButton" />

      <div v-if="showDirectMessageButton" class="actions">
        <a class="button" @click="setActiveChannelById(user.channelId); return false;">
          <fa-icon 
            :icon="['fas', 'comments']" 
            size="2x"
          />
        </a>
        <div class="spacer" v-if="callEnabled"></div>
        <a class="button" v-if="callEnabled" @click="call({ audio: true }); return false;">
          <fa-icon 
            :icon="['fas', 'phone']" 
            size="2x"
          />
        </a>
        <div class="spacer" v-if="callEnabled"></div>
        <a class="button" v-if="callEnabled" @click="call({ video: true, audio: true }); return false;">
          <fa-icon 
            :icon="['fas', 'video']" 
            size="2x"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

import Avatar from '@/components/Avatar';
import VerifiedIcon from '@/components/VerifiedIcon';

export default {
  name: 'UserCard',
  props: [
    'user'
  ],
  components: {
    Avatar,
    VerifiedIcon
  },
  computed: {
    ...mapGetters([
      'visualSettings',
      'hasVideoOrAudioInput'
    ]),
    ...mapState([
      'uuid',
      'activeChannel'
    ]),
    showDirectMessageButton() {
      return this.activeChannel.id !== this.user.channelId && this.visualSettings.userDirectMessaging;
    },
    callEnabled() {
      return this.user.uuid !== this.uuid;
    }
  },
  methods: {
    ...mapActions([
      'setActiveChannelById',
      'loadMediaDevices',
      'initCall'
    ]),
    async call({ audio, video }) {
      this.setActiveChannelById(this.user.channelId);
      await this.loadMediaDevices();
      if (this.hasVideoOrAudioInput) {
        this.initCall({ audio, video });
      } else {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Audio/Video Not Found',
          text: 'Unable to find audio or video devices to begin call. Please check your browser settings.',
          duration: 5000
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.icon {
  display: table;
  width: 100%;
  font-weight: normal;
  font-size: 14.4px;
  color: rgba(47, 49, 56, 1);
  line-height: 1.2;
}

.sidebar {
  width: 1px;
  display: table-cell;
}

.main {
  padding: 0 0 0 12px;
  display: table-cell;
  vertical-align: top;
}

label {
  display: block;
  font-size: 11.2px;
  color: rgba(47, 49, 56, 0.35);
  margin: 12px 0 0 0;
}

.row {

  &:first-child {

    label {
      margin-top: 0;
    }
  }
}

span {
  display: block;
  margin: 2px 0 0 0;
  word-break: break-word;

  &.title {
    font-weight: bold;
    font-size: 12px;
  }
}

hr {
  margin: 12px 0;
  border: 0;
  height: 1px;
  background: rgba(47,49,56,0.1);
}

.actions {
  display: table;
  width: 100%;
  border-collapse: collapse;
  border: 0;

  .spacer {
    display: table-cell;
    width: 8px;
    min-width: 8px;
  }

  a.button {
    display: table-cell;
    margin: 0 0 0 0;
    min-width: 33%;
    width: 100%;
    font-size: 8px;
    font-family: "Poppins";
    text-align: center;
    height: 30px;
    line-height: 40px;
    padding: 0 15px;
    color: #fff;
    box-sizing: border-box;
    border-radius: 4px;
    border: 0;
    background: #2bbd7e;
    cursor: pointer;

    > * {
      position: relative;
      top: 3px;
    }
  }
}
</style>
